import WhyRejectRerouteForm from './container';

export default WhyRejectRerouteForm;
